import { Instant } from "@js-joda/core";
import { create } from "zustand";

type ChartDialogOptions = {
  refTime: string | undefined;
};

type ChartDialogState = {
  isOpen: boolean;
  closeDialog: () => void;
  openDialog: (options?: ChartDialogOptions) => void;
  refTime: string | undefined;
  dateFrom: Instant | undefined;
  dateTo: Instant | undefined;
  header: string | undefined;
  setDateFrom: (date: Instant) => void;
  setDateTo: (date: Instant) => void;
  setHeader: (header: string) => void;
};

const useChartDialogStore = create<ChartDialogState>(set => ({
  isOpen: false,
  refTime: undefined,
  dateFrom: undefined,
  dateTo: undefined,
  header: undefined,
  closeDialog: () => set({ isOpen: false, dateFrom: undefined, dateTo: undefined }),
  openDialog: (options = { refTime: undefined }) => set({ ...options, isOpen: true }),
  setDateFrom: (date: Instant) => set({ dateFrom: date }),
  setDateTo: (date: Instant) => set({ dateTo: date }),
  setHeader: (header: string) => set({ header }),
}));

export default useChartDialogStore;
